import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Helmet } from 'react-helmet';
import { Typography, Grid, CircularProgress, InputAdornment, TablePagination } from '@mui/material';
import { injectIntl } from 'react-intl';
import { appendSeoBrand } from 'utils/seo';
import { fetchTag } from 'actions/TagActions';
import Formsy from 'formsy-react';
import SearchIcon from '@mui/icons-material/Search';
import TextInput from 'components/inputs/TextInput';
import CardDesign from 'components/CardDesign';
import * as qs from 'query-string';
import { paginationParameters } from 'utils/url';
import _ from 'lodash';

export class TagPage extends React.Component {
  constructor(props) {
    super(props);

    const params = qs.parse(location.search);

    this.state = {
      page: parseInt(params['page']) || 0,
      search: params['filter'] || ''
    };
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
  }

  componentDidMount() {
    this.props.fetchTag(window.SITE_ID, this.props.match.params.tagSlug, this.props.locale);
  }

  handleChangePage(event, newpage) {
    this.setState({page: newpage});
  }

  handleChangeSearch(data) {
    this.setState({search: data.product_search});
    this.setState({page: 0});
  }

  render() {
    const { tag, isFetching, intl, cardDesigns } = this.props;
    const rowsPerPage = 8;

    paginationParameters(location, this.state.page, this.state.search);

    if (tag) {
      var products = tag.card_designs;
      if (this.state.search) {
        products = _.filter(products, (p) => { return p.name.toLowerCase().includes(this.state.search.toLowerCase()) });
      }
    }

    return (
      <React.Fragment>
        {isFetching &&
          <center><CircularProgress color="inherit" size={50} /></center>
        }

        {tag &&
          <React.Fragment>
            <Helmet>
              <title>{appendSeoBrand(tag.page_title)}</title>
              <meta name="description" content={tag.description} />
              <meta name="robots" content={window.APP_ENV === 'production' ? 'index' : 'noindex'} />
              <link rel="canonical" href={window.location.href} />
            </Helmet>

            <Typography variant='h4' component="h1" align='center' className="bottom-space">{tag.name}</Typography>
            <Grid container spacing={8} justify={tag.card_designs.length === 1 ? 'center' : 'flex-start'} align='center' className="content-item-container">
              {tag.card_designs.length > 12 &&
                <Grid size={{xs: 12}} align="left">
                  <Formsy onChange={this.handleChangeSearch}>
                    <TextInput type="search" name="product_search" value={this.state.search} label={intl.formatMessage({id: "order.search", defaultMessage: "Search"})} inlineLabel
                               inputProps={{
                                 endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>
                               }}
                    />
                  </Formsy>
                </Grid>
              }
              {products.slice(this.state.page * rowsPerPage, this.state.page * rowsPerPage + rowsPerPage).map((card_design, index) =>
                <Grid key={index} size={{xs: 12, md: 3}}>
                  <CardDesign template='grid' cardDesign={card_design}/>
                </Grid>
              )}
              {products.length > rowsPerPage &&
                <Grid size={{xs: 12}}>
                  <TablePagination
                    rowsPerPageOptions={[rowsPerPage]}
                    component="div"
                    count={products.length}
                    rowsPerPage={rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                  />
                </Grid>
              }

              <Grid size={{xs: 12}} style={{marginTop: '3em'}} />
            </Grid>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    locale: state.locale.locale,
    isFetching: state.tag.isFetching,
    tag: state.tag.tag
  }
}

const mapDispatchToProps = {
  fetchTag: (siteId, slug, locale) => fetchTag(siteId, slug, locale)
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TagPage));
